import { Component, Input, OnInit } from '@angular/core';
import { Segmento } from '../../_models/segmento';
import { SegmentoTipoVinculacion } from '../../_models/segmento-tipo-vinculacion';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SegmentoTipoVinculacionService } from '../../_services/segmento-tipo-vinculacion.service';
import { forkJoin } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaItem } from '../../_models/lista-item';
import { NavService } from '../../_services/_nav.service';

@Component( {
  selector: 'app-segmento-tipo-vinculacion',
  templateUrl: 'segmento-tipo-vinculacion.component.html',
} )

export class SegmentoTipoVinculacionComponent implements OnInit {

  @Input() segmento: Segmento;
  carInformacionInicial = true;
  lisSegmentoVinculacion: SegmentoTipoVinculacion[] = [];
  lisSegmentoVinculacionTodos: SegmentoTipoVinculacion[] = [];
  formulario: FormGroup;
  guardando = false;
  lisVinculaciones: SelectItem[] = [];
  lisTodasVinculaciones: ListaItem[] = [];
  submitted = false;
  columnas: any[];

  constructor( private segTipoVinculacionServicio: SegmentoTipoVinculacionService,
               private lisServicio: ListaService,
               private navServicio: NavService,
               private conServicio: ConfirmationService,
               private fb: FormBuilder ) {
  }

  ngOnInit(): void {
    this.formulario = this.fb.group( {
      idTipoVinculacion: [ null, [ Validators.required ] ]
    } );

    this.columnas = [
      { field: 'tipoVinculacion', header: this.navServicio.buscarMensaje( 'SEGMENTOTIPOVINCULACION.LBL_TIPOVINCULACION' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.segTipoVinculacionServicio.listadoPorSegmento( this.segmento.idSegmento ),
      this.lisServicio.getMasterDetails( 'ListasTiposVinculaciones' ) ).subscribe( ( [ lisSegmentoVinculacion, lisTiposVinculaciones ] ) => {
      this.lisTodasVinculaciones = lisTiposVinculaciones;
      this.lisSegmentoVinculacionTodos = lisSegmentoVinculacion;
      this.cargarSegmentoVinculaciones();
      this.cargarListaTiposVinculaciones();
      this.carInformacionInicial = false;
    } );
  }

  cargarSegmentoVinculaciones() {
    this.lisSegmentoVinculacion = this.lisSegmentoVinculacionTodos.filter( x => x.indicadorHabilitado );
  }

  cargarListaTiposVinculaciones() {
    this.lisVinculaciones = [];
    this.lisTodasVinculaciones.map( ( s: ListaItem ) => {
      if ( !this.lisSegmentoVinculacion.find( x => x.idTipoVinculacion === s.idLista ) ) {
        this.lisVinculaciones.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const registro = this.formulario.value;
      const existe = this.lisSegmentoVinculacionTodos.find( x => x.idTipoVinculacion == registro.idTipoVinculacion );
      if ( existe ) {
        existe.indicadorHabilitado = true;
        this.segTipoVinculacionServicio.actualizar( existe ).subscribe( rta => {
          this.salirGuardando( 2 );
        } );
      } else {
        const a = {} as SegmentoTipoVinculacion;
        a.idTipoVinculacion = registro.idTipoVinculacion;
        a.idSegmento = this.segmento.idSegmento;
        a.indicadorHabilitado = true;
        this.segTipoVinculacionServicio.crear( a ).subscribe( rta => {
          a.idSegmentoTipoVinculacion = rta.idSegmentoTipoVinculacion;
          const nom = this.lisTodasVinculaciones.find( y => y.idLista == a.idTipoVinculacion );
          if ( nom ) {
            a.tipoVinculacion = nom.nombre;
          }
          this.lisSegmentoVinculacionTodos.push( a );
          this.salirGuardando( 1 );
        } );
      }
    }
  }

  salirGuardando( tipo: number ) {
    this.cargarSegmentoVinculaciones();
    this.cargarListaTiposVinculaciones();
    this.submitted = false;
    this.formulario.reset();
    this.guardando = false;
    this.navServicio.setMesage( tipo );
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar( registro: SegmentoTipoVinculacion ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'tipo-vinculacion',
      accept: () => {
        this.carInformacionInicial = true;
        registro.indicadorHabilitado = false;
        this.segTipoVinculacionServicio.actualizar( registro ).subscribe( regActualizado => {
          this.cargarSegmentoVinculaciones();
          this.cargarListaTiposVinculaciones();
          this.navServicio.setMesage(2);
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );
  }


}
